import locale from "localization/en";

export const keyAccountLogsColumn = [
  { key: "collectionId", text: locale.collectionId },
  {
    key: "shiftDate",
    text: locale.shiftDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  {
    key: "collectionDateAndTime",
    text: locale.collectionDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  { key: "amount", text: locale.amount },
  { key: "siNumSoa", text: locale.siNumSoa },
  { key: "keyAccountName", text: locale.keyAccountName },
  { key: "paymentMethod", text: locale.paymentMethod },
  { key: "action", text: locale.action },
];
